import { showErrorDialog } from '../stores/errorDialogSlice';
const { fetch: originalFetch } = window;

const errorDialog = {
  show: true,
  title: 'Server Error',
  message: 'Unknown error occurred.',
  showReloadButton: false,
  statusCode: undefined,
};

const fetchInterceptor = async (dispatch, keycloak, args) => {
  const [resource, config] = args;

  const authConfig = keycloak.token
    ? {
        ...config,
        headers: {
          ...config.headers,
          Authorization: `Bearer ${keycloak.token}`,
        },
      }
    : { ...config, headers: { ...config.headers } };

  const start = Date.now();

  const response = await originalFetch(resource, authConfig).catch((error) => {
    dispatch(showErrorDialog(errorDialog));
    return Promise.reject(error);
  });

  console.debug(resource, Date.now() - start);

  if (response.ok || response.status === 412) return response;

  if (response.status === 401 || response.status === 403) {
    errorDialog.title = 'Unauthorized';
    errorDialog.message = 'Your session may have been expired. Please reload the page.';
    errorDialog.showReloadButton = true;
  } else if (response.status === 400) {
    errorDialog.title = 'Bad Request';
    errorDialog.message = 'Validation failed';
  }

  errorDialog.statusCode = response.status;
  dispatch(showErrorDialog(errorDialog));

  return response;
};

export default fetchInterceptor;
